import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../../constant';
import '../../form.css'

const Index = ({ state, onChange, isFinalSubmitting, setIsFinalSubmitting, onSubmit, history, siteManager, data }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w300">
                                    <p>Enquiry Reference</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">1.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Project</p>
                                </td>
                                <td className="tb-input-value">
                                    <select
                                        className="form-control"
                                        value={state.project.value}
                                        name={'project'}
                                        disabled={data ? true : false}
                                        onChange={(e) => onChange(e)}
                                    >

                                        <option value={''}>Select Project</option>
                                        {state.project.options.map((item) => {
                                            return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">2.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Hull no.</p>
                                </td>
                                <td className="tb-input-value">
                                    <select
                                        className="form-control"
                                        disabled={data ? true : false}
                                        value={state.ship.value}
                                        name={'ship'}

                                        onChange={(e) =>
                                            onChange(e)
                                        }
                                    >

                                        <option value={''}>Select Hull</option>
                                        {state.ship.options.map((item) => {
                                            return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">3.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Name of Owner</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={
                                            state.ship.options.find((item) => item.ID == state.ship.value)?.OWNER_NAME || ''
                                        }
                                        placeholder="Autofill"
                                    />

                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Name of vessel</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={
                                            state.ship.options.find((item) => item.ID == state.ship.value)?.SHIP_NAME || ''
                                        }
                                        placeholder="Autofill"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">5.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Type of vessel</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={
                                            state.ship.options.find((item) => item.ID == state.ship.value)?.SHIP_TYPE_NAME || ''
                                        }
                                        placeholder="Autofill"

                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">6.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Port of Registry</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"

                                        placeholder='Enter Port of Registry'
                                        name='portOfRegistry'
                                        onChange={onChange}
                                        value={state.portOfRegistry.value}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">7.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Official number</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name='officialNumber'
                                        onChange={onChange}

                                        value={state.officialNumber.value}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">8.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>classification</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name='classification'
                                        value={state.classification.value}
                                        onChange={onChange}

                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">9.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Year Built</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name='yearBuilt'
                                        value={state.yearBuilt.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">10.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Date of Keel-Laying</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="date"
                                        className="form-control"
                                        name='dateOfKeelLaying'
                                        value={state.dateOfKeelLaying.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">11.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Date of Launching</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="date"
                                        className="form-control"
                                        name='dateOfLaunching'
                                        value={state.dateOfLaunching.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">12.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Date of Delivery</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="date"
                                        className="form-control"
                                        name='dateOfDelivery'
                                        value={state.dateOfDelivery.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">13.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Side letter if any</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name='sideLetter'
                                        value={state.sideLetter.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">14.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Remarks (if any):</p>
                                </td>
                                <td className="tb-input-value">
                                    <textarea name='remark'
                                        value={state.remark.value}
                                        onChange={onChange} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b">
                                            <p>
                                                IN WITNESS WHEREOF, OneSea solutions Pte. Ltd. has
                                                hereby executed this declaration on
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <textarea name='declaration'
                                                value={state.declaration.value}
                                                onChange={onChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <table className="mrt10">
                                <tbody>
                                    <tr>
                                        <td className="hd-b" colSpan={2}>
                                            <p className="mb-3">Company</p>
                                            <p />
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td className="input-td w150">
                                            <p className="s2">BY:</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td className="input-td w150">
                                            <p className="s2">Name</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    value={siteManager}
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td colSpan={2} className="input-td">
                                            <p className="s2 mt-4">Title: Site Manager</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6">
                            <table className="mrt10">
                                <tbody>
                                    <tr>
                                        <td className="hd-b">
                                            <p className="mb-3">&nbsp;</p>
                                            <p />
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td className="input-td w150">
                                            <p className="s2">BY:</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td className="input-td w150">
                                            <p className="s2">Name</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td colSpan={2} className="input-td">
                                            <p className="s2 mt-4">
                                                Title: Head of Projects New building
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        <div class="final-checkbox">
                            <div class="form-check mt-2">
                                <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                                <label class="form-check-label" for="productdiscountCheck1">Send New Building Pre Launching Check List to Office for Review</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4"></div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button

                            className="btn btn-success text-white"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <a
                            href={constant.Authedcomponent.submitNewBuildingConfirmationOfVesselCompletionAndDelivery.url}
                            className="btn btn-danger ms-3 text-white"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                        >
                            Cancel
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)